<div id="map" [ngStyle]="{ width: width(), height: height() }"></div>
@if (heatLayer(); as heatLayer) {
  <app-control-slider [heatLayer]="heatLayer" (radiusChange)="onRadiusChange($event)"> </app-control-slider>
}
